import { type TemplateOnlyComponent } from '@ember/component/template-only';
import { array } from '@ember/helper';
import BsPopover from 'ember-bootstrap/components/bs-popover';

type HelpPopoverPlacement = 'top' | 'bottom' | 'left' | 'right';

interface HelpPopoverSignature {
  Args: {
    /** Accessible name for the help trigger button. */
    ariaLabel: string;
    /** Popover header; defaults to ariaLabel when omitted. */
    title?: string;
    placement?: HelpPopoverPlacement;
  };
  Blocks: {
    default: [];
  };
  Element: HTMLButtonElement;
}

const HelpPopover: TemplateOnlyComponent<HelpPopoverSignature> = <template>
  <button
    type="button"
    class="btn btn-link btn-sm p-0 lh-1 text-primary border-0 align-baseline"
    ...attributes
  >
    <iconify-icon icon="ph:info" inline aria-hidden="true" />
    <span class="visually-hidden">{{@ariaLabel}}</span>
    <BsPopover
      @renderInPlace={{true}}
      @placement={{if @placement @placement "right"}}
      @title={{if @title @title @ariaLabel}}
      @triggerEvents={{array "hover" "focus"}}
      class="ll-popover-small shadow shadow-lg"
    >
      <div class="p-3">
        {{yield}}
      </div>
    </BsPopover>
  </button>
</template>;

export default HelpPopover;
